export default __webpack_public_path__ + "static/media/Schedule.15679c68.png";